<template>
  <section class="form-list">
    <el-form
      class="form"
      ref="form"
      :rules="rules"
      :model="post"
      label-position="right"
      label-width="120px"
    >
      <el-form-item label="所属学员">
        <v-avatar-nickname
          :value="student.selfie"
          :nickname="student.student_name"
          :link-page-name="RouteConfig.studentDetail.name"
          :link-page-id="post.student_id"
          :avatar-size="50"
        />
      </el-form-item>

      <el-form-item label="代金券 ID">{{ id }}</el-form-item>

      <el-form-item label="代金券类型">{{ post.voucher_type_name }}</el-form-item>

      <el-form-item label="面额">{{ post.amount_in_cents | toYuan }} 元</el-form-item>

      <el-form-item label="有效时长">
        <template v-if="post.valid_duration_seconds > 0">{{ post.valid_duration_seconds | formatDuration }}</template>
        <span v-else-if="post.expire_time > 0">指定时间过期</span>
        <span v-else class="info-color">未设置</span>
      </el-form-item>

      <el-form-item label="过期时间">
        <template v-if="post.expire_time">{{ post.expire_time | timeToYmdHi }}</template>
        <span v-else class="success-color">永久有效</span>
      </el-form-item>

      <el-form-item label="发放方式">
        <span v-for="state in findVoucherIssueType(post.issue_type)" :key="state.value">
          {{ state.name }}
        </span>
      </el-form-item>

      <el-form-item label="办理时间">{{ post.add_time | timeToYmdHi }}</el-form-item>

      <el-form-item label="办理门店">{{ post.store_name }}</el-form-item>

      <el-form-item label="退券原因" prop="del_remark">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入 2 ~ 250 字的退券原因"
          v-model="post.del_remark"
          maxlength="250"
          show-word-limit
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">确认退券</el-button>
        <el-button @click="RouteConfig.voucherList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { show, destroy } from '@/api/voucher';
import { toYuan } from '@/filters';
import { findVoucherIssueType } from '@/enums/voucherIssueTypes';

export default {
  name: RouteConfig.voucherDelete.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    student: {
      selfie: '',
      student_name: '',
    },
    post: {
      student_id: 0,
      voucher_type_name: '',
      amount_in_cents: 0,
      valid_duration_seconds: 0,
      expire_time: 0,
      issue_type: 0,
      add_time: 0,
      store_name: '',
      update_time: 0,
      del_remark: '',
      use_time: 0,
    },
    rules: {
      del_remark: [{ required: true, message: '请输入退券原因', trigger: 'blur' }],
    },
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.fetchData();
  },
  methods: {
    toYuan,
    findVoucherIssueType,
    async fetchData() {
      const { isError, data } = await show(this.id);
      if (isError || !data) return;

      const { post } = this;
      const updateData = {};
      Object.keys(post).forEach(key => {
        if (key in data) updateData[key] = data[key];
      });
      Object.assign(post, updateData);

      if (data.student) {
        this.student = {
          selfie: data.student.selfie || '',
          student_name: data.student.student_name || '',
        };
      }
    },
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const { isError } = await destroy(this.id, {
          update_time: this.post.update_time,
          del_remark: this.post.del_remark,
        });
        this.isSaving = false;
        if (!isError) RouteConfig.voucherDeletedList.push();
      });
    },
  },
};
</script>
